import React from 'react'
import cx from 'classnames'

import FlowTextEditor from 'common/builder/components/misc/FlowTextEditor'
import { IMCTextEditorRef } from 'components/MCTextEditor/MCTextEditor'

type InputProps = React.ComponentProps<typeof FlowTextEditor>

export const Input = React.forwardRef<IMCTextEditorRef, InputProps>((props: InputProps, ref) => {
  return (
    <div className={cx('p-relative p-x-xs p-y-xxs b-b')}>
      <FlowTextEditor {...props} ref={ref} withDefaultStyles minRows={1} maxRows={6} isValid />
    </div>
  )
})
